var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showModal)?_c('BaseModal',{attrs:{"display-close-button":_vm.displayCloseButton}},[_c(_vm.currentModal,{tag:"component"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }